// extracted by mini-css-extract-plugin
module.exports = {"Menu":"bgq_a bhf_h","Menu__offsetParent":"bgq_b bhf_bj","Menu__trigger--shadowed":"bgq_c"};